import { combineReducers } from "redux";
import CustomizerReducer from "./customizer/CustomizerReducer";
import chatReducer from "./chats/ChatReducer";
import notesReducer from "./notes/NotesReducer";
import emailReducer from "./email/EmailReducer";
import createEPOReducer from "./expense-purchase-order/EPOReducer";
import roleReducer from "./role-rights/RoleReducer";
const RootReducers = combineReducers({
  CustomizerReducer,
  chatReducer,
  notesReducer,
  emailReducer,
  createEPOReducer,
  roleReducer,
});

export default RootReducers;
